import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'

export function dateGreaterThanValidator(fieldName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const date1 = control.value
    const date2 = control.parent?.value[fieldName]

    if (date1 && date2) {
      const dateOne = new Date(date2)
      const dateTwo = new Date(date1)

      if (dateTwo > dateOne) {
        return null
      }

      return { message: `Date must be greater than ${fieldName}` }
    }

    return null // No error
  }
}
